"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../api/ApplicationContext");
var _ThemeUtils = require("../api/theme/ThemeUtils");
var _Header = _interopRequireDefault(require("./Header"));
var _TimeoutModal = _interopRequireDefault(require("../components/TimeoutModal"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _SiteRoutes = _interopRequireDefault(require("../business/SiteRoutes"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _Menu = _interopRequireDefault(require("../api/Menu"));
var _SiteConfiguration = require("../api/auth/SiteConfiguration");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Theme = props => {
  const [showFramework, setShowFramework] = (0, _react.useState)(_ApplicationContext.ApplicationContext.getShowFramework());
  const {
    loader,
    site
  } = props;
  const {
    pathname
  } = window.location;
  const [themeCss, setThemeCss] = (0, _react.useState)(null);
  const [customizationCssClass, setCustomizationCssClass] = (0, _react.useState)();

  // Respond to the `storage` event
  const preferencesUpdatedHandler = () => {
    const appThemeCss = _ApplicationContext.ApplicationContext.getThemeCss();
    if (appThemeCss !== themeCss) {
      setThemeCss(appThemeCss);
    }
    const tempCustomizationCssClass = _ApplicationContext.ApplicationContext.getCustomizationIds() && _ApplicationContext.ApplicationContext.getCustomizationIds().length > 0 ? `customization-${_ApplicationContext.ApplicationContext.getCustomizationIds().join(' customization-')}` : null;
    if (tempCustomizationCssClass !== customizationCssClass) {
      setCustomizationCssClass(tempCustomizationCssClass);
    }
  };
  _core.PostMessage.listenCore(preferencesUpdatedHandler, ['application-preferences-updated']);
  (0, _react.useEffect)(() => {
    if (_ApplicationContext.ApplicationContext.hasSiteDefinitionChanged(pathname)) {
      setShowFramework(_ApplicationContext.ApplicationContext.getShowFramework());
    }
    if (pathname === '/login.html') {
      let existingThemeCss = document.getElementById('applicationThemeCss');
      if (existingThemeCss) {
        existingThemeCss.remove();
      }
      _ApplicationContext.ApplicationContext.setCurrentApplicationPreferences(null);
      return;
    }
    let menuItemList = [];
    if (site?.public?.siteMenu) {
      const menu = _Menu.default.from({
        menuItems: site?.public?.siteMenu
      });
      let tempList = [];
      tempList = menu.getMenuItemsWithComponents();
      menuItemList.push(...tempList);
    }
    if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu) {
      let tempList = [];
      tempList = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getMenuItemsWithComponents();
      menuItemList.push(...tempList);
    }
    let currentMenu = null;
    menuItemList.filter(menuItem => menuItem.path && menuItem.path.length > 0 && menuItem.customizationId && menuItem.customizationId !== -1 && (typeof menuItem.children === 'undefined' || menuItem.children.length === 0) && (menuItem.pageTitle && menuItem.pageTitle.length > 0 || menuItem.title && menuItem.title.length > 0 || menuItem.name && menuItem.name.length > 0)).filter(menuItem => (0, _reactRouter.matchPath)(pathname, menuItem.path)).forEach(item => {
      currentMenu = item;
    });
    if (currentMenu === null) {
      return;
    }
    if (currentMenu?.customizationId) {
      (0, _SiteConfiguration.getApplicationPreferences)(_ApplicationContext.ApplicationContext.getClientId(), _ApplicationContext.ApplicationContext.getApiBasePath(), currentMenu.customizationId);
    }
  }, [props?.site?.public?.siteMenu, window.location.pathname]);
  let existingThemeCss = document.getElementById('applicationThemeCss');
  if (existingThemeCss) {
    existingThemeCss.remove();
  }
  if (themeCss) {
    existingThemeCss = document.createElement('link');
    existingThemeCss.id = 'applicationThemeCss';
    existingThemeCss.setAttribute('rel', 'stylesheet');
    existingThemeCss.setAttribute('type', 'text/css');
    existingThemeCss.setAttribute('href', themeCss);
    document.head.append(existingThemeCss);
  }
  const frameworkClassName = showFramework ? 'framework ' : 'no-framework ';
  const framedClassName = (0, _ThemeUtils.isFramed)() ? ' framed ' : '';
  const themeNameClassName = props.themeName && props.themeName !== 'undefined' ? _ApplicationContext.ApplicationContext.getTheme() : '';
  const slimViewClassName = props.slimView ? ' is-slim ' : ' is-not-slim ';
  const customizationClassName = customizationCssClass ? ` ${customizationCssClass}` : ' ';
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "theme-container",
    className: `${frameworkClassName}${themeNameClassName}${framedClassName}${slimViewClassName}${customizationClassName}`
  }, showFramework && /*#__PURE__*/_react.default.createElement(_Header.default, {
    loginPath: _ApplicationContext.ApplicationContext.getLoginPath(),
    logoutPath: _ApplicationContext.ApplicationContext.getLogoutPath(),
    profilePath: _ApplicationContext.ApplicationContext.getProfilePath(),
    site: _ApplicationContext.ApplicationContext.getSiteDefinition(),
    contactUs: props.contactUs,
    loginLink: props.loginLink,
    logoutLink: props.logoutLink,
    welcome: props.welcome,
    images: props.images,
    logo: props.logo,
    logoAlt: props.logoAlt,
    slimView: props.slimView
  }), showFramework && /*#__PURE__*/_react.default.createElement(_TimeoutModal.default, null), /*#__PURE__*/_react.default.createElement(_SiteRoutes.default, _extends({}, props, {
    loader: loader,
    showFramework: showFramework
  })), showFramework && props.footer || showFramework && /*#__PURE__*/_react.default.createElement(_Footer.default, props));
};
Theme.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  themeName: _propTypes.default.string,
  history: _propTypes.default.shape({
    listen: _propTypes.default.func
  }),
  logo: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  logoAlt: _propTypes.default.string,
  contactUs: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginLink: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  logoutLink: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  welcome: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loader: _propTypes.default.func.isRequired,
  slimView: _propTypes.default.bool
  // site: PropsTypes.shape({public: PropTypes.shape({siteMenu: PropTypes.shape({id: PropTypes.number})})}),
};
Theme.defaultProps = {
  slimView: true
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Theme);
//# sourceMappingURL=Theme.js.map